<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-agreement comp">
        <el-checkbox
            v-if="protocol.length > 0"
            v-model="isAllChecked"
            name="type"
            class="agreement-checkbox"
        >
            <div class="agree-list">
                <b>我已阅读并同意:</b>
                <span
                    v-for="item of protocol"
                    :key="item.id"
                    class="protocol-item"
                    v-on:click.prevent="agreementCon(item)"
                >
                    《{{ item.title }}》
                </span>
            </div>
        </el-checkbox>
        <el-dialog
            :title="agrCon.title"
            :visible.sync="centerDialogVisible"
            :fullscreen="isFullscreen"
            append-to-body
            max-height="80%"
            width="900px"
        >
            <div v-if="agrCon.content" v-html="agrCon.content" />
            <div
                v-else-if="filePath"
                v-loading="fileLoading"
                style="justify-content: center; display: flex"
            >
                <iframe
                    ref="iframe"
                    style="width: 800px; height: 400px; border: none"
                    :src="filePath"
                    v-on:load="onLoad"
                ></iframe>
            </div>
            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="confirmCon">我已知晓</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import commonApi from "@/api/common";
import Vue from "vue";

const fileUrl = "/js/pdfjs/web/viewer.html";

export default {
    name: "Agreement",
    props: {
        data: {
            type: String,
            required: true
        },
        value: {
            // v-model绑定的值，父组件的protocol
            type: Boolean,
            default: false
        },
        policytype: {
            type: String,
            default: ""
        },
        // 允许调用方按协议类型排除部分协议，例如过滤 M 类转账交易协议
        excludePolicyTypes: {
            type: [String, Array],
            default: ""
        }
    },
    data() {
        return {
            protocol: [],
            centerDialogVisible: false,
            agrCon: {},
            isFullscreen: false,
            filePath: "",
            fileLoading: false,
            isAllChecked: false, // 协议勾选状态
            agreementLoading: false,
            pendingAgreementSubmit: false,
            agreementRequestSeq: 0
        };
    },
    watch: {
        data() {
            this.getAgreement();
        },
        policytype() {
            this.getAgreement();
        },
        excludePolicyTypes: {
            deep: true,
            handler() {
                this.getAgreement();
            }
        },
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.submitAgreement();
                }
            }
        }
        // 勾选/取消勾选时，双向同步给父组件的v-model（不要放开，放开直接触发下一步）
        /* isAllChecked(val) {
            this.$emit("input", val);
            this.$emit("all-read", val);
        } */
    },
    mounted() {
        // 页面加载就自动获取协议列表，默认展示/隐藏
        this.getAgreement();
    },
    methods: {
        // 兼容字符串/数组两种传参，统一转成协议类型数组
        normalizeExcludePolicyTypes() {
            const source = Array.isArray(this.excludePolicyTypes)
                ? this.excludePolicyTypes
                : String(this.excludePolicyTypes || "").split(",");
            return source.map((item) => String(item || "").trim()).filter(Boolean);
        },
        // 协议集合变化后，重置勾选状态，避免沿用旧协议的已同意结果
        resetAgreementState() {
            this.isAllChecked = false;
            this.$emit("input", false);
        },
        submitAgreement() {
            if (this.agreementLoading) {
                this.pendingAgreementSubmit = true;
                return;
            }
            this.pendingAgreementSubmit = false;
            if (this.protocol.length > 0 && !this.isAllChecked) {
                this.$alert(
                    "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                    "提示",
                    { confirmButtonText: "确定" }
                );
                this.$emit("all-read", false);
                return;
            }
            this.$emit("all-read", true);
            if (this.protocol.length > 0) {
                commonApi.agreementLeaveTracesLog(
                    this,
                    {
                        eventid:
                            Vue.prototype.$const.RECORD.cms_protocol_agreement_agree +
                            "/" +
                            this.data,
                        eventname: "协议同意"
                    },
                    this.protocol
                );
            }
        },
        handleAgreementLoaded() {
            this.agreementLoading = false;
            if (this.pendingAgreementSubmit) {
                this.$nextTick(() => {
                    this.submitAgreement();
                });
            }
        },
        handlePdfUrlChange(val) {
            if (val) {
                this.fileLoading = true;
                const fileGet = this.$util.fileDownloadPath(val);
                this.filePath =
                    fileUrl +
                    "?file=" +
                    encodeURIComponent(fileGet) +
                    `&rand=${Date.now()}` +
                    "#page=1&toolbar=0";
            }
        },
        onLoad() {
            const iframe = this.$refs.iframe;
            this.$nextTick(() => {
                iframe.contentWindow.PDFViewerApplication.appConfig.toolbar.container.classList.add(
                    "hidden"
                );
                this.fileLoading = false;
            });
        },
        // 未勾选也能点击预览协议
        agreementCon(val) {
            if (val.content) {
                this.agrCon = val;
                this.centerDialogVisible = true;
            } else if (val.fileid) {
                this.agrCon = val;
                this.handlePdfUrlChange(val.fileid);
                this.centerDialogVisible = true;
            }
        },
        confirmCon() {
            this.centerDialogVisible = false;
        },
        getAgreement() {
            const requestSeq = ++this.agreementRequestSeq;
            const scene = typeof this.data === "string" ? this.data.trim() : "";
            this.agreementLoading = true;
            this.resetAgreementState();
            this.protocol = [];
            if (this.$util.isEmpty(scene) && this.$util.isEmpty(this.policytype)) {
                this.handleAgreementLoaded();
                return;
            }
            this.$util
                .getProtocol(scene, "", this.policytype)
                .then((res) => {
                    if (requestSeq !== this.agreementRequestSeq) {
                        return;
                    }
                    // 本次协议过滤只在前端做列表裁剪，不影响原始协议接口
                    const excludePolicyTypes = this.normalizeExcludePolicyTypes();
                    this.protocol = (res || []).filter((item) => {
                        return !excludePolicyTypes.includes(String(item.policytype || "").trim());
                    });
                })
                .catch(() => {
                    if (requestSeq !== this.agreementRequestSeq) {
                        return;
                    }
                    this.protocol = [];
                })
                .finally(() => {
                    if (requestSeq !== this.agreementRequestSeq) {
                        return;
                    }
                    this.handleAgreementLoaded();
                });
        }
    }
};
</script>
<style lang="scss">
.comp-agreement {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    margin-left: -80px;

    .agreement-checkbox {
        width: auto !important;
        display: flex;
        align-items: center;
        cursor: pointer;

        .el-checkbox__input {
            vertical-align: middle;
            margin-top: 0 !important;
        }

        .el-checkbox__label {
            padding-left: 8px !important;
            line-height: 22px !important;
            color: $text-color1;
            cursor: pointer;
            margin: 0 !important;
            display: inline-flex;
            align-items: center;

            .agree-list {
                display: inline-flex;
                align-items: center;
                flex-wrap: wrap;
            }

            b {
                float: none !important;
                font-weight: normal;
                color: red;
                line-height: 22px;
                margin-right: 4px;
            }

            .protocol-item {
                float: none !important;
                color: $color-b;
                cursor: pointer;
                line-height: 22px;
                display: inline-block;
                margin: 0 4px;
                &:after {
                    content: "、";
                    color: $text-color1;
                }
                &:last-child:after {
                    content: "";
                }
                &:hover {
                    color: var(--color-primary);
                }
            }
        }
    }

    .el-dialog__body {
        max-height: 70vh !important;
        overflow-y: auto;
        padding: 20px;
    }
    .dialog-footer {
        text-align: center;
    }
}
</style>
